const routes = [
    {
        path: '/contabilidade/mensagens',
        alias: ['/contabilidade/mensagens/index'],
        component: () => import('../views/Listar'),
    },
    {
        path: '/contabilidade/mensagens/visualizar/:id',
        component: () => import('../views/Visualizar'),
    },
    {
        path: '/contabilidade/mensagens/enviar_mensagem',
        component: () => import('../views/Adicionar'),
    },
    {
        path: '/contabilidade/mensagens/enviar_mensagem/:id',
        component: () => import('../views/ResponderMensagem'),
    },
    
   
]

export default routes
